import "./polyfills/arrayToSorted";
import { init } from "gemi/client";
import { installStaleBundleRecovery } from "./observability/staleBundleRecovery";
import RootLayout from "./views/RootLayout";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b30065b901d88222bcbacdb984d29d8f@o4510758871564288.ingest.de.sentry.io/4510758877266000",
  // Disabled off the production build: `bun run dev` runs with import.meta.env.PROD === false, so the
  // browser SDK never initializes a transport and sends nothing to the prod Sentry project.
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/folioai\.com\/api/],
});

// Before init: a chunk can fail during the first hydration, not only on a later navigation.
installStaleBundleRecovery();

init(RootLayout);
